























































































import { Component, Prop, Watch } from "vue-property-decorator";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { ISnapshotSignRequest } from "@/models/snapshot-sign-request.entity";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import ContextMenu from "../utility/ContextMenu.vue";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import CreateSnapshotSignRequestDialog from "./CreateSnapshotSignRequestDialog.vue";
import { ISnapshot } from "@/models/snapshot.entity";
import { mixins } from "vue-class-component";
import PermissionMixin from "@/mixins/PermissionMixin.vue";

@Component({
  components: {
    ContextMenu,
    ConfirmActionDialog,
    CreateSnapshotSignRequestDialog
  },
  filters: { simpleDoubleDigitDate }
})
export default class SnapshotDetailSignRequestCard extends mixins(PermissionMixin) {
  @Prop() request!: ISnapshotSignRequest;
  @Prop() snapshot?: ISnapshot;

  isDeleteDialogActive = false;
  isDeleteLoading = false;
  sharedContent: ISharedContent | null = null;
  isLoadingSharing = false;
  isSending = false;

  mounted() {
    this.getSharing();
  }

  @Watch("request.id", { deep: true })
  onRequestChanged() {
    this.getSharing();
  }

  get sharingEmail() {
    return (this.sharedContent?.emailAddresses || [])[0] || "";
  }

  get sharingCreated() {
    return this.sharedContent?.timestamp?.created || null;
  }

  get displayedEmail() {
    return this.sharingEmail;
  }

  get displayedDate() {
    return this.sharingCreated;
  }

  copyUrl() {
    this.sharedContent?.copyLinkToClipboard();
  }

  async sendMail() {
    this.isSending = true;
    const createSnapshotSignRequestDialog = this.$refs
      .createSnapshotSignRequestDialog as CreateSnapshotSignRequestDialog;

    if (!this.sharedContent) {
      const sharedContent = await new SharedContent({
        partnerId: this.request.partnerId,
        refs: [{ refType: ResourceEnum.SNAPSHOT_SIGN_REQUEST, refId: this.request.id }]
      }).create();
      this.sharedContent = sharedContent;
    }
    createSnapshotSignRequestDialog.openForExisting(this.request, this.sharedContent);
    this.isSending = false;
  }

  async getSharing() {
    try {
      this.isLoadingSharing = true;
      await this.request.fetchSharedDocument();
      this.sharedContent = this.request.sharedDocument || null;
    } catch (e) {
      this.$log?.error?.(e);
      this.sharedContent = null;
    } finally {
      this.isLoadingSharing = false;
    }
  }

  openDeleteDialog() {
    this.isDeleteDialogActive = true;
  }

  async onDelete() {
    try {
      this.isDeleteLoading = true;
      await this.request.delete();
      this.$emit("deleted", this.request.id);
      this.isDeleteDialogActive = false;
    } catch (err) {
      this.$emit("error", err);
    } finally {
      this.isDeleteLoading = false;
    }
  }
}
